import { OperationStatus } from './OperationStatus';

export class Operation {
    readonly status: OperationStatus;

    constructor(status: OperationStatus) {
        this.status = status;
    }
}
